import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Avatar, Box, Button, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@material-ui/core";
import "./TransactionTable.css";

const useStyles = makeStyles({
  table: {
    // minWidth: 350,
    minWidth: 320,
  },
});

export default function TransactionTable(props) {
  const classes = useStyles();

  // Getting Accounts Info
  let transactions;
  let availableBalance;
  let accountNo;
  // let miniStatementInfo = props.miniStatementData.map((item, i) => {
  //   console.log("item from Transaction Table: ", item);
  //   transactions = item.Body.Payload.Collection;
  //   availableBalance = item.Body.Payload.Available_Balance;
  //   accountNo = item.Body.Payload.Account_No;
  // });

  return (
    <div className="ms-wrapper ms-wrapper-bot ms-wrapper-border ms-width-70" style={{ border: "8px solid rgba(244, 176, 53, 0.8)"}}>
      <Box>
        <Typography align="center" variant="subtitle2" display="block" style={{ color: "rgba(12, 77, 162, 1)", fontSize: "20px" ,textAlign:"center",fontWeight:"600"}}>
          Mini-Statement
        </Typography>
      </Box>
      <Box>
      {/* <Typography variant="subtitle1">
          {accountNo}
      </Typography>
      <Typography variant="subtitle1">
          {availableBalance}
      </Typography> */}
      <List>
      <ListItem>
        {/* <ListItemAvatar>
          <Avatar>
            <ImageIcon />
          </Avatar>
        </ListItemAvatar> */}
        <ListItemText primary="Account" secondary={accountNo} />
      </ListItem>
      <ListItem>
        <ListItemText primary="Balance" secondary={availableBalance} />
      </ListItem>
      </List>
      </Box>
    {/* <Button onClick={()=>props.openTransactionModal()} size="small" color="primary">Open</Button> */}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Date</TableCell>
              <TableCell align="center">Amount</TableCell>
              <TableCell align="center">Type</TableCell>
              {/* <TableCell align="right">Fat&nbsp;(g)</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((transactions, i) => (
              <TableRow key={i}>
                {/* <TableCell component="th" scope="row">
                  {transactions.Value_Date}
                </TableCell> */}
                <TableCell align="center">
                  {transactions.Value_Date}
                  {/* {new Date(transactions.Value_Date.replace(/(\d+)(\d{2})(\d{2})/g, '$1-$2-$3')).toLocaleDateString("en-GB")} */}
                </TableCell>
                {/* <TableCell align="center">{transactions.Amount}</TableCell> */}
                <TableCell align="center">{parseFloat(transactions.Amount).toFixed(2)}</TableCell>
                <TableCell align="center">{transactions.Type_Of_Txn}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
